import { gql } from '@provision/graphql-client';
import { PARTNER_HOLIDAY_FRAGMENT } from './partner-holiday.fragment';

export const CREATE_PARTNER_HOLIDAY_QUERY = gql`
  mutation CreatePartnerHoliday($data: PartnerHolidayDataInput) {
    createPartnerHoliday(data: $data) {
      ...PartnerHolidayFields
    }
  }
  ${PARTNER_HOLIDAY_FRAGMENT}
`;

export const DELETE_PARTNER_HOLIDAY_QUERY = gql`
  mutation DeletePartnerHoliday($conditions: [ConditionInput]) {
    deletePartnerHoliday(conditions: $conditions) {
      id
    }
  }
`;

export const GET_PARTNER_HOLIDAY_QUERY = gql`
  query GetPartnerHoliday($params: QueryParams) @entity(name: "PartnerHoliday") {
    getPartnerHoliday(queryParams: $params) {
      records {
        ...PartnerHolidayFields
      }
    }
  }
  ${PARTNER_HOLIDAY_FRAGMENT}
`;

export const UPDATE_PARTNER_HOLIDAY_QUERY = gql`
  mutation UpdatePartnerHoliday(
    $conditions: [ConditionInput]
    $data: PartnerHolidayDataInput
  ) {
    updatePartnerHoliday(conditions: $conditions, data: $data) {
      ...PartnerHolidayFields
    }
  }
  ${PARTNER_HOLIDAY_FRAGMENT}
`;
